<div class="bolide-loader-container">
    <div class="bolide-loader-brand" aria-label="AI Campus Visible Social Impact loading">
        <div class="bolide-loader-logo" aria-hidden="true"></div>
        <div class="bolide-loader-copy">
            <span class="bolide-loader-line bolide-loader-line-primary">AI Campus</span>
            <span class="bolide-loader-line bolide-loader-line-secondary">Visible Social Impact</span>
        </div>
    </div>
</div>
